import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Link } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import { Divider } from "@mui/material";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKAvatar from "components/MKAvatar";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";

import ProfileInfoCard from "pages/Profile/ProfileInfoCard";
import ProfileDetails from "pages/Dashboard/components/ProfileDetails";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Routes
import { routes } from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/somosure/portrait-smiling-young-african-man.jpg";
import profilePicture from "assets/images/bruce-mars.jpg";

import { getSingleUser } from "actions/userActions";

function Profile() {
  const dispatch = useDispatch();
  const [editMode, setEditMode] = useState(false);

  const singleUser = useSelector((state) => state.singleUser);
  const { userSingle } = singleUser;

  useEffect(() => {
    dispatch(getSingleUser());
  }, [dispatch, userSingle?.length]);

  const handleEditMode = () => {
    setEditMode(!editMode);
  };

  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "external",
          route: "#",
          label: "Call Us",
          color: "default",
        }}
        sticky
      />
      <MKBox>
        <MKBox
          minHeight="45vh"
          width="100%"
          sx={{
            backgroundImage: ({
              functions: { linearGradient, rgba },
              palette: { gradients },
            }) =>
              `${linearGradient(
                rgba(gradients.dark.main, 0.2),
                rgba(gradients.dark.state, 0.2)
              )}, url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "top",
            display: "grid",
            placeItems: "center",
          }}
        />
        <Card
          sx={{
            p: 2,
            mx: { xs: 2, lg: 3 },
            mt: -8,
            mb: 4,
            backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
              rgba(white.main, 0.8),
            backdropFilter: "saturate(200%) blur(30px)",
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
          }}
        >
          <MKBox component="section" py={{ xs: 6, sm: 12 }}>
            <Container>
              <Grid container item xs={12} justifyContent="center" mx="auto">
                <MKBox mt={{ xs: -16, md: -20 }} textAlign="center">
                  <MKAvatar
                    src={userSingle?.profile_image}
                    alt={userSingle?.name}
                    size="xxl"
                    shadow="xl"
                  />
                </MKBox>
                <Grid container justifyContent="center" py={6}>
                  <Grid item xs={12} md={7} mx={{ xs: "auto", sm: 6, md: 1 }}>
                    <MKBox
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      mb={1}
                    >
                      <MKTypography variant="h3">
                        {userSingle?.name}{" "}
                      </MKTypography>
                      {/* <Link to="/dashboard"> */}
                      <MKButton
                        onClick={handleEditMode}
                        variant="outlined"
                        color="info"
                        size="small"
                      >
                        {editMode ? "Cancel" : "Edit Profile"}
                      </MKButton>
                      {/* </Link> */}
                    </MKBox>
                    <Grid container spacing={3} mb={3}>
                      <Grid item>
                        <MKTypography
                          component="span"
                          variant="body2"
                          fontWeight="bold"
                        >
                          {userSingle?.policies?.length}&nbsp;
                        </MKTypography>
                        <MKTypography
                          component="span"
                          variant="body2"
                          color="text"
                        >
                          Policy Orders
                        </MKTypography>
                      </Grid>
                      <Grid item>
                        <MKTypography
                          component="span"
                          variant="body2"
                          fontWeight="bold"
                        >
                          {userSingle?.claims?.length}&nbsp;
                        </MKTypography>
                        <MKTypography
                          component="span"
                          variant="body2"
                          color="text"
                        >
                          Claims
                        </MKTypography>
                      </Grid>
                      <Grid item>
                        <MKTypography
                          component="span"
                          variant="body2"
                          fontWeight="bold"
                        >
                          {userSingle?.orders?.length}&nbsp;
                        </MKTypography>
                        <MKTypography
                          component="span"
                          variant="body2"
                          color="text"
                        >
                          Orders
                        </MKTypography>
                      </Grid>
                    </Grid>
                    {editMode ? (
                      <>
                        <Divider />
                        <MKBox pt={1} pb={2} px={2}>
                          <ProfileDetails />
                        </MKBox>
                      </>
                    ) : (
                      <MKBox width="100%">
                        <ProfileInfoCard
                          title="Client Account Information"
                          currentInfo={userSingle}
                          active={userSingle?.active}
                          info={{
                            fullName: userSingle?.name,
                            mobile: userSingle?.phone,
                            email: userSingle?.email,
                            idNumber: userSingle?.idNumber,
                            dob: moment(userSingle?.date_of_birth).format(
                              "DD/MM/YYYY"
                            ),
                            joined: moment(userSingle?.created_at).fromNow(),
                          }}
                          action={{ route: "", tooltip: "Edit Profile" }}
                          shadow={false}
                        />
                      </MKBox>
                    )}
                    {/* <MKTypography
                      variant="body1"
                      fontWeight="light"
                      color="text"
                    >
                      Decisions: If you can&apos;t decide, the answer is no. If
                      two equally difficult paths, choose the one more painful
                      in the short term (pain avoidance is creating an illusion
                      of equality). Choose the path that leaves you more
                      equanimous. <br />
                      <MKTypography
                        component="a"
                        href="#"
                        variant="body1"
                        fontWeight="light"
                        color="info"
                        mt={3}
                        sx={{
                          width: "max-content",
                          display: "flex",
                          alignItems: "center",

                          "& .material-icons-round": {
                            transform: `translateX(3px)`,
                            transition:
                              "transform 0.2s cubic-bezier(0.34, 1.61, 0.7, 1.3)",
                          },

                          "&:hover .material-icons-round, &:focus .material-icons-round":
                            {
                              transform: `translateX(6px)`,
                            },
                        }}
                      >
                        More about me{" "}
                        <Icon sx={{ fontWeight: "bold" }}>arrow_forward</Icon>
                      </MKTypography>
                    </MKTypography> */}
                  </Grid>
                </Grid>
              </Grid>
            </Container>
          </MKBox>
        </Card>
      </MKBox>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Profile;
